import React, { useEffect, useState } from "react";
import Loader from "../../../../Components/GlobalLoader/Loader";
import Table from "../../../../Components/Tables/Table";
import PageHeader from "../../../../Layout/PageHeader";
import { usePagination } from "../../../../hooks/usePagination";
import { ApiResponse } from "../../../../model/common/apiResponse";
import { useSearchStore } from "../../../../store/search/searchStore";
import { fetchPickPlan } from "../service/pickplan.service";
import { PickPlanListProps } from "../model/PickPlanList.type";
import { useSorting } from "../../../../hooks/useSorting";
import { formatSearchDate, isValidDate } from "../../../../Utility/Utility";

const PickPlanList: React.FC<PickPlanListProps> = ({
  columns,
  db_columns,
  pageName,
  headerName,
  addUrl,
  listUrl,
  checkboxStatus = true,
  search_columns,
  advancedFilterData = null,
  warehouseId,
  refreshTrigger
}) => {
  const { currentPage, handlePageChange, perPage } = usePagination();
  const [data, setData] = useState<ApiResponse<any> | null>(null);
  const { sortingData, handleSortChange } = useSorting(handlePageChange);
  const { searchTerm, previousSearchTerm, setPreviousTerm } = useSearchStore();

  useEffect(() => {
    if (searchTerm !== previousSearchTerm && currentPage !== 1) {
      handlePageChange(1);
    }

    let order: any[] = [];
    if (sortingData.column.column_name && sortingData.direction) {
      order = [
        {
          column: sortingData.column.column_name,
          dir: sortingData.direction,
        },
      ];
    }

    let filterPayload: any[] = [];
    if (warehouseId) {
      filterPayload.push(["warehouse.id", "=", warehouseId]);
    }
    const formattedSearch = isValidDate(searchTerm) ? formatSearchDate(searchTerm) : searchTerm;

    const payload: any = {
      columns: db_columns,
      search_columns: search_columns,
      conditions: filterPayload,
      limit: perPage,
      page: currentPage,
      search: formattedSearch,
      order: [
        {
          column: "pick_plan_config.id",
          dir: "desc",
        },
      ],
    };

    if (order.length > 0) {
      Object.assign(payload, { order });
    }

    setData(null);
    fetchPickPlan(currentPage, payload).then((response) => {
      setData(response ?? null);
      setPreviousTerm(searchTerm);
    });
  }, [currentPage, searchTerm, sortingData, warehouseId, advancedFilterData, refreshTrigger]);


  return data ? (
    <>
      <PageHeader addUrl={addUrl} listUrl={listUrl} name={pageName} />

      <div className="clearfix"></div>

      <h5 className="text-start mt-1 mb-3">{headerName}</h5>

      <div>
        <Table
          customClassName="sph-table-color"
          enableSorting={true}
          columns={columns}
          data={data?.data?.results || []}
          pagination={{
            recordsPerPage: perPage,
            totalRecords: data?.data?.recordsTotal,
            currentPage: currentPage,
            onCurrentPageChange: handlePageChange,
          }}
          CheckboxStatus={checkboxStatus}
          sortingData={sortingData}
          onSortChange={handleSortChange}
        />
      </div>
    </>
  ) : (
    <Loader />
  );
};

export default PickPlanList;
